import logo from './logo.svg';
import './App.css';
import JigsawPuzzleGenerator from './JigsawPuzzleGenerator';

function App() {
  return (
    <div className="App">
        <JigsawPuzzleGenerator />
    </div>
  );
}

export default App;
